import * as Sentry from '@sentry/nextjs'
import { useEffect, useState } from 'react'

import { isBlank } from 'utils'

const useCustomAccount = (customer) => {
  const { id, email } = customer || {}

  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchCustomer = async ({ email, id }) => {
    const url = `/api/customer?email=${encodeURIComponent(email)}&id=${encodeURIComponent(id)}`

    try {
      const response = await fetch(url)
      const data = await response.json()

      setData(data)
      setLoading(false)
    } catch (error) {
      Sentry.captureException(error)
      return null
    }
  }

  useEffect(() => {
    if (isBlank(id) || isBlank(email)) return

    fetchCustomer({ id, email })
  }, [id, email])

  return { data, loading }
}

export default useCustomAccount
